<template>
  <div class="main">
    <baseMap ref="mapRef" class="map" @mounted="mapMounted" />
  </div>
</template>

<script setup>
  import baseMap from '@/components/map/base_map'

  import { ref, watch } from 'vue'

  const mapRef = ref()
  const markers = ref([])

  const data = ref({
    west: {
      carOut: 1,
      carIn: 22,
      personOut: 333,
      personIn: 4444,
    },
    north: {
      carOut: 66,
      carIn: 60,
      personOut: 66,
      personIn: 60,
    },
    east: {
      carOut: 66,
      carIn: 60,
      personOut: 66,
      personIn: 60,
    },
  })

  const points = [
    {
      lat: 22.74468226259652,
      lng: 114.55404155532212,
      name: '石化园区西门',
      id: 'west',
    },
    {
      lat: 22.7639150363516,
      lng: 114.58851211754407,
      name: '石化园区北门',
      id: 'north',
    },
    {
      lat: 22.767573108679223,
      lng: 114.63635599780388,
      name: '石化园区东门',
      id: 'east',
    },
  ]

  function mapMounted(map, L) {
    addMarkers(map, L)
  }

  function addMarkers(map, L) {
    points.forEach((point) => {
      const marker = L.marker([point.lat, point.lng]).addTo(map)
      const popup = addPopup(map, L, point)
      markers.value.push({ marker, popup })

      // 监听弹出框的打开/关闭状态
      marker.on('click', (e) => {})
    })
  }

  function addPopup(map, L, point) {
    const popup = L.popup({
      offset: L.point(0, -30),
      className: 'custom-popup',
      closeButton: false, // 移除关闭按钮
      closeOnClick: false, // 禁止点击地图时关闭弹出框
      autoClose: false, // 禁止自动关闭其他弹出框
    })
      .setContent(getPopupContent(point))
      .setLatLng([point.lat, point.lng])
      .addTo(map)

    return popup
  }

  function getPopupContent(point) {
    const content = data.value[point.id]
    return `
       <div class='custom-popup-content'>
         <div class="popup-title">${point.name}</div>
         <div class='popup-top'>
           <div class="popup-mini-title">入园</div>
           <div class="popup-box">
             <div class='popup-item'><div class="car_icon"></div> <span class='popup-number popup-green-number artistic_font_numbers'>${content.carIn}</span></div>
             <div class='popup-item'><div class="person_icon"></div> <span class='popup-number popup-green-number artistic_font_numbers'>${content.personIn}</span></div>
           </div>
         </div>
         <div class='popup-bottom'>
           <div class="popup-mini-title">出园</div>
           <div class="popup-box">
             <div class='popup-item'><div class="car_icon"></div><span class='popup-number popup-blue-number artistic_font_numbers'>${content.carOut}</span></div>
             <div class='popup-item'><div class="person_icon"></div> <span class='popup-number popup-blue-number artistic_font_numbers'>${content.personOut}</span></div>
           </div>
         </div>
       </div>`
  }

  function updatePopup() {
    markers.value.forEach(({ popup }) => {
      const point = points.find((p) => popup.getLatLng().lat === p.lat)
      popup.setContent(getPopupContent(point))
    })
  }
</script>

<style lang="less" scoped>
  /deep/.custom-popup {
    width: 186px;
  }
  /deep/.custom-popup .leaflet-popup-content {
    margin: 0;
  }
  /deep/.custom-popup-content {
    padding: 10px 0 5px 0;
  }
  /deep/.custom-popup .leaflet-popup-content-wrapper {
    background-color: rgba(0, 0, 0, 0.705) !important;
  }
  /deep/ .custom-popup .leaflet-popup-tip {
    background-color: rgba(0, 0, 0, 0.724) !important;
  }
  /deep/.custom-popup .leaflet-popup-content {
    color: rgba(255, 255, 255, 0.533);
  }
  /deep/.custom-popup .popup-title {
    text-align: center;
    font-size: 17px;
    font-weight: bold;
    margin-bottom: 15px;
  }
  /deep/.custom-popup .popup-mini-title {
    flex: 1;
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 5px;
    text-align: center;
  }
  /deep/.custom-popup .popup-box {
    flex: 1;
  }
  /deep/.custom-popup .popup-number {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 5px;
  }
  /deep/.custom-popup .popup-blue-number {
    color: #0077fff5;
  }
  /deep/.custom-popup .popup-green-number {
    color: #4caf4ff3;
  }
  /deep/.custom-popup .popup-top {
    margin-bottom: 15px;
  }
  /deep/.custom-popup .popup-top,
  /deep/.custom-popup .popup-bottom {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  /deep/.custom-popup .popup-item {
    // margin-bottom: 3px;
  }
</style>
